module.exports = __webpack_public_path__ + "img/icon_option_set_3.24a8dc1b.svg";